<div pTooltip="Enable Tax Rate" tooltipPosition="top" style="display: inline-block">
    <p-inputSwitch [(ngModel)]="enable" (onChange)="loadTaxList(enable)"></p-inputSwitch>
</div>

<p-table [value]="allRates" *ngIf="enable" dataKey="id" [expandedRowKeys]="expandedRowsClass">
    <ng-template pTemplate="header">
        <tr>
            <th style="max-width: 3rem"></th>
            <th>Name</th>
            <th>Address Type</th>
            <!-- <th>Vendor Name</th> -->
            <th>Tax Rate</th>
            <th>Is Active</th>
            <!-- <th>Is Default</th> -->
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-country let-expanded="expanded">
        <tr class="parentRow">
            <td class="action">
                <button type="button" [pRowToggler]="country" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="width: 20px;height: 20px;"></button>
            </td>
            <td>{{country.countryName}}</td>
            <td>{{country.addressType}}</td>
            <td></td>
            <td></td>
            <td></td>
            <!-- <td></td> -->
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="showAddRate(country)"><i class="pi pi-plus"></i></span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-country>
        <ng-container *ngFor="let rate of country.tax">
            <tr>
                <td></td>
                <td>{{rate?.name}}</td>
                <td>{{rate?.code}}</td>
                <!-- <td>
                    <span *ngIf="rate.type && rate.type.name==discountConstantsProperty.AmountDiscountType">${{rate.taxRate}}</span>
                    <span *ngIf="rate.type && rate.type.name==discountConstantsProperty.PercentageDiscountType">{{rate.taxRate}}%</span>
                </td> -->
                <!-- <td>{{rate.vendor && rate.vendor.vendorName}}</td> -->
                <td>{{rate.taxRate}}%</td>
                <td>{{rate.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
                <!-- <td>
                    <p-radioButton [disabled]="rate.statusId==statusConstants.INACTIVE" [value]="true" [(ngModel)]="rate.isDefault" (onClick)="taxRateDefault(rate)"></p-radioButton>
                    {{rate.isDefault?answertypeConstants.Yes:answertypeConstants.No}}
                </td> -->
                <td class="action">
                    <span class="btnBars p-mr-0" (click)="showEditRate(rate)" pTooltip="Edit" tooltipPosition="top"><i
                  class="pi pi-pencil"></i></span>
                    <span class="btnBars p-mr-0" *ngIf="!rate.isDefault" (click)="checkDeleteStatus(rate)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                </td>
            </tr>
        </ng-container>
    </ng-template>
</p-table>

<!-- Tax country add-->
<p-dialog header="{{taxCountryAddDialogHeader}}" [(visible)]="displayTaxCountryAdd" [modal]="true" [responsive]="true" [style]="{width: '60vw'}" (onHide)="taxForm.reset()">
    <form [formGroup]="taxCountryForm">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-6">
                <label>Country <span style="color: red;">*</span></label>
                <p-dropdown [options]="countries" optionLabel="name" optionValue="id" [filter]="true" placeholder="Select Country" appendTo="body" formControlName="countryId" (onChange)="changeCountry($event)"></p-dropdown>
            </div>
            <div class="p-col-12 p-md-6">
                <label>Address Type <span style="color: red;">*</span></label>
                <p-dropdown [options]="addressTypes" formControlName="addressTypeId" optionLabel="name" optionValue="id" placeholder="Select Address Type" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayTaxCountryAdd = false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton [disabled]="!taxCountryForm?.valid" (click)="saveTaxCountry()" label="Save"></button>
    </p-footer>
</p-dialog>

<!-- Tax rate add/edit -->
<p-dialog header="{{addEditRateHeader}}" [(visible)]="displayRateAdd" [modal]="true" [responsive]="true" [style]="{width: '60vw'}" (onHide)="taxForm.reset()">
    <!-- <p-steps [model]="menus" [readonly]="false" [(activeIndex)]="activeIndex" class="stepper no-label"></p-steps> -->
    <form [formGroup]="taxForm">
        <div class="header">
            <h5>Rate Information
                <p-inputSwitch class="header-switch" formControlName="statusId" *ngIf="!isAddTaxRate" [disabled]="statusDisabled"></p-inputSwitch>
            </h5>
        </div>
        <div class="card" *ngIf="activeIndex == 0">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Country <span style="color: red;">*</span></label>
                    <p-dropdown [options]="countries" optionLabel="name" optionValue="id" [filter]="true" placeholder="Select Country" appendTo="body" formControlName="countryId" (onChange)="changeCountry($event)" [disabled]="disableCountrySelection"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Address Type <span style="color: red;">*</span></label>
                    <p-dropdown [options]="addressTypes" formControlName="addressTypeId" optionLabel="name" optionValue="id" placeholder="Select Address Type" [ngModelOptions]="{standalone: true}" appendTo="body" [disabled]="disableAddressTypeSelection"></p-dropdown>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Name <span style="color: red;">*</span></label>
                    <input pInputText type="text" formControlName="name" />
                    <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>State/Province</label>
                    <p-dropdown [options]="states" optionLabel="name" optionValue="id" [filter]="true" placeholder="Select State" appendTo="body" formControlName="stateId" [showClear]="true"></p-dropdown>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Zipcode (Optional)</label>
                    <input type="text" pInputText placeholder="B1034,C3213" formControlName="zipCode" />
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Product Category (Optional)</label>
                    <p-treeSelect [options]="CategoryLists" [metaKeySelection]="false" appendTo="body" selectionMode="multiple" formControlName="taxProductCategory" placeholder="Select Item"></p-treeSelect>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <!-- <div class="p-col-6">
                    <label>Vendor Name <span style="color: red;">*</span></label>
                    <p-dropdown [options]="vendors" formControlName="vendorId" optionLabel="vendorName" optionValue="id" placeholder="Select Vendor" [ngModelOptions]="{standalone: true}" appendTo="body">
                    </p-dropdown>
                </div> -->
                <div class="p-col-6">
                    <label>Finance Account <span style="color: red;">*</span></label>
                    <p-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body" placeholder="Select Financial Account" formControlName="financialAccountId" display="comma" [metaKeySelection]="false" selectionMode="single"></p-treeSelect>
                </div>
                <div class="p-col-6">
                    <label>Tax Rate<span style="color: red;">*</span></label>
                    <p-inputNumber [ngModelOptions]="{standalone: true}" [min]="0" (keypress)="isNumberKey($event)" formControlName="taxRate" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="4">
                    </p-inputNumber>
                </div>
            </div>
        </div>

        <!-- <div class="card" *ngIf="activeIndex == 1">
            <ng-container formArrayName="subTax">
                <ng-container *ngFor="let subTaxForm of subTax?.controls; let i = index">
                    <div class="p-field p-formgrid p-grid" [formGroup]="getFormGroupAt(i)">
                        <div class="p-col-12 p-md-4">
                            <label>Tax Code <span style="color: red;">*</span></label>
                            <p-dropdown [options]="subTaxCodes" formControlName="code" optionLabel="code" editable="true" placeholder="Select Tax Code" appendTo="body" dataKey="id" (onChange)="showAddTaxCode($event, i)"></p-dropdown>
                        </div>
                        <div class="p-col-12 p-md-3">
                            <label>Type <span style="color: red;">*</span></label>
                            <p-dropdown [options]="rateTypes" formControlName="typeId" optionLabel="name" placeholder="Select Type" [ngModelOptions]="{standalone: true}" appendTo="body" [disabled]="disableRateType"></p-dropdown>
                        </div>
                        <div class="p-col-12 p-md-4" *ngIf="getFormGroupAt(i)?.controls['typeId']?.value?.name == discountConstantsProperty.PercentageDiscountType">
                            <label>Percentage <span style="color: red;">*</span></label>
                            <input type="text" pInputText formControlName="taxRate" [ngModelOptions]="{standalone: true}" appNumbersOnly>
                        </div>
                        <div class="p-col-12 p-md-1">
                            <p-button icon="pi pi-plus" (click)="addSubTax()" *ngIf="i == 0"></p-button>
                            <p-button icon="pi pi-trash" (click)="deleteSubTax(i)" *ngIf="i > 0"></p-button>
                        </div>
                    </div>

                </ng-container>
            </ng-container>
        </div> -->
    </form>
    <p-footer>
        <button type="button" pButton (click)="cancel()" label="Cancel" class="p-button-secondary"></button>
        <!-- <button type="button" pButton *ngIf="activeIndex == 1" (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
        <button type="button" pButton *ngIf="activeIndex == 0" label="Next" (click)="nextStep(activeIndex)" [disabled]="!taxForm.controls.name.value || !taxForm.controls.addressTypeId.value || !taxForm.controls.countryId.value || !taxForm.controls.vendorId.value || !taxForm.controls.financialAccountId.value"></button> 
        <button type="button" pButton *ngIf="activeIndex == 1" [disabled]="!taxForm?.valid" (click)="saveRate(taxForm.value)" label="Save"></button>-->
        <button type="button" pButton [disabled]="!taxForm?.valid" (click)="saveRate(taxForm.value)" label="Save"></button>
    </p-footer>
</p-dialog>


<!-- Tax code add dialog-->
<!-- <p-dialog header="Add New Tax Code" [modal]="true" [(visible)]="displayAddTaxCode" [style]="{width: '45vw'}" (onHide)="hideAddTaxCode()">
    <form [formGroup]="taxCodeForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Name</label>
                    <input type="text" pInputText style="width: 100%;" name="groupName" formControlName="name">
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button pButton (click)="hideAddTaxCode()" label="Cancel" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="addSubTaxCode()" [disabled]="!taxCodeForm.valid"></button>
    </p-footer>
</p-dialog> -->